import { Router } from '@angular/router';
import { MarkParamsWithExam, MarkParamsWithTask, MarkQuestion } from '@fuulea/mark-paper';
import { TabletApp } from '@common';
import { MarkUtilsService } from '@app/mark/mark-utils.api.service';

/**
 * 跳转阅卷
 * @param router
 * @param params
 * @param title
 */
export const toMark = (router: Router, params: MarkParamsWithExam | MarkParamsWithTask, title: string) => {
  if (TabletApp.isTabletApp()) TabletApp.postMessage('mark', params);
  else {
    params['title'] = title;
    router.navigate(['/mark'], { queryParams: params });
  }
};

export const getTaskMarkQuestion = async (
  markApis: MarkUtilsService,
  taskId: number,
  questionId?: number
): Promise<{ questionIds: number[]; appeal: boolean }> => {
  // 获取拍照组
  const photogroup = await markApis.loadTaskPhotogroup(taskId);
  let group: MarkQuestion = null;
  if (questionId) {
    group = photogroup.find(item => item.questionId.includes(questionId));
  } else {
    group = photogroup.find(item => {
      return item.appealCount > 0 || item.unmarkedCount > 0;
    });
  }

  return {
    questionIds: group?.questionId || null,
    appeal: group?.appealCount > 0 || false,
  };
};
